import React from 'react';
import {
  FormCategoryDTO,
} from 'dtos';
import Button from 'pages/Dashboard/components/Button';
import ButtonCheckbox from 'pages/Dashboard/components/ButtonCheckbox';
import Spinner from 'pages/Dashboard/components/Spinner';
import FillingStepNav from 'views/EMR/components/FillableForm/components/FillingStepNav';

type Props = {
  currentStep: number;
  totalSteps: number;
  category: FormCategoryDTO;
  includeVisitNote: boolean;
  onIncludeVisitNoteChange: (checked: boolean) => void;
  onConfirm: () => void;
  onPrev: () => void;
  isSaving?: boolean;
};

export default function DocumentOptionsStep({
  currentStep,
  totalSteps,
  category,
  includeVisitNote,
  onIncludeVisitNoteChange,
  onConfirm,
  onPrev,
  isSaving = false,
}: Props) {
  return (
    <div className="flex flex-col gap-4 px-4 w-3/4 max-w-[870px]">
      <ButtonCheckbox
        id="include-visit-note"
        className="!p-0 w-full !justify-start"
        label="Include visit note with this form"
        checked={includeVisitNote}
        disabled={isSaving}
        onChange={(_event, checked) => onIncludeVisitNoteChange(checked)}
        classes={{ button: '!w-full flex-1 min-w-0 !h-8' }}
      />
      <div className="flex gap-4 flex-1 items-center justify-between">
        <Button
          variant="contained"
          color="primary"
          disabled={isSaving}
          className="min-w-32 w-auto h-8 !py-0 !capitalize flex gap-2 items-center"
          onClick={onConfirm}
          type="button"
        >
          {isSaving && <Spinner />}
          {isSaving ? 'Saving...' : `Save ${category.name}`}
        </Button>
        <FillingStepNav
          currentStep={currentStep}
          totalSteps={totalSteps}
          onPrev={onPrev}
          isNextDisabled
        />
      </div>
    </div>
  );
}
